import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listMyAssignedRuns } from "../lib/api";
import { clientError } from "../lib/clientMessage";
import { loadPmoReport, type PmoReportLoad } from "../lib/pmoReportLoader";
import { currentAssessment } from "../lib/respondent";
import { PmoClientReport } from "./PmoClientReport";

// The respondent's own report (/respond/report): their current assessment,
// once submitted, through the shared loader and the shared client report.
// The screen decides only WHICH run; the loader and the pure model decide
// everything that is printed.

type State =
  | { kind: "loading" }
  | { kind: "not-yet" }
  | { kind: "error"; message: string }
  | { kind: "ready"; load: Extract<PmoReportLoad, { kind: "ready" }> };

export function RespondReport() {
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    void (async () => {
      try {
        const mine = currentAssessment(await listMyAssignedRuns());
        const load = mine ? await loadPmoReport(mine.run_id) : null;
        if (!load || load.kind !== "ready") {
          setState({ kind: "not-yet" });
          return;
        }
        setState({ kind: "ready", load });
      } catch (e) {
        setState({ kind: "error", message: clientError("report", e).message });
      }
    })();
  }, []);

  if (state.kind === "loading") return <p>Preparing your report…</p>;
  if (state.kind === "error") return <div className="error-banner" role="alert">{state.message}</div>;
  if (state.kind === "not-yet") {
    return (
      <div className="card empty-state">
        <h3>Your report is not ready yet</h3>
        <p>The report is produced when the assessment is submitted.</p>
        <Link className="btn" to="/respond">Go to your assessment</Link>
      </div>
    );
  }

  return <PmoClientReport model={state.load.model} scale={state.load.scale} />;
}
